import { useEffect } from 'react';

const imageCache = new Set<string>();

export const preloadImage = (src: string): Promise<void> => {
  return new Promise((resolve, reject) => {
    if (!src || imageCache.has(src)) {
      resolve();
      return;
    }

    const img = new Image();
    img.onload = () => {
      imageCache.add(src);
      resolve();
    };
    img.onerror = reject;
    img.src = src;
  });
};

export const usePreloadImages = (images: string[], priority = false) => {
  useEffect(() => {
    if (!priority) return;

    const preloadAll = async () => {
      try {
        await Promise.all(images.map(src => preloadImage(src)));
      } catch (error) {
        console.warn('Error preloading images:', error);
      }
    };

    preloadAll();
  }, [images, priority]);
};

export const isImageCached = (src: string): boolean => {
  return imageCache.has(src);
};